'use strict';

var RomSummaryDTDChartFilterFactory = function RomSummaryDTDChartFilterFactory(DemandFilter, angularHelper) {
  var filtersNamesList = ['ROMOptGroupWeekFilterFactory', 'ROMSummaryCabinFilterFactory', 'ROMSummaryPOSFilterFactory', 'ROMSummaryDOWFilterFactory'];
  var injectedFilters = angularHelper.getProvidersByNames(filtersNamesList);
  function RomSummaryDTDChartFilter() {
    DemandFilter.call(this, 'rom-summary-mode', 'days-to-departure-thematic-chart');
    this.registerFilters(injectedFilters);
  }
  RomSummaryDTDChartFilter.constructor = RomSummaryDTDChartFilter;
  RomSummaryDTDChartFilter.prototype = Object.create(DemandFilter.prototype);
  return RomSummaryDTDChartFilter;
};
RomSummaryDTDChartFilterFactory.$inject = ['DemandFilterFactory', 'AngularHelper'];
module.exports = RomSummaryDTDChartFilterFactory;